import { Route } from '@angular/router';
import { UiBreadcrumbItem, UiPageChromeConfig } from '@system-dyg/shared/ui';

const BI_CRUMB: UiBreadcrumbItem = {
  id: 'bi',
  label: 'Business Intelligence',
};

interface BiLandingRouteConfig {
  readonly path: string;
  readonly moduleId: string;
  readonly activeMenubarId: string;
  readonly title: string;
  readonly breadcrumbs: readonly UiBreadcrumbItem[];
  readonly loadComponent: NonNullable<Route['loadComponent']>;
}

/** Construye una ruta de página BI con un chrome uniforme. */
export function biLandingRoute(config: BiLandingRouteConfig): Route {
  return {
    path: config.path,
    pathMatch: 'full',
    loadComponent: config.loadComponent,
    data: {
      chrome: {
        moduleId: config.moduleId,
        activeMenubarId: config.activeMenubarId,
        title: config.title,
        titleBarMode: 'form',
        breadcrumbItems: [BI_CRUMB, ...config.breadcrumbs],
      } satisfies UiPageChromeConfig,
    },
  };
}
